<app-left-menu></app-left-menu>
<app-catalog-filter></app-catalog-filter>
